// ESM-Huelle um lib/scripts/pos/CLS_CVoucher.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals
// modulweit deklarieren (nur ZUGEWIESENE Namen - nur-gelesene wie
// process/lp behalten bewusst ihren vorbestehenden ReferenceError).
var dataSet, i, text, printer;
// ---------------------------------------------------------------------------
// object  CBalanceDataSet
// ---------------------------------------------------------------------------
function CBalanceDataSet(type) {
    this.type = type || 0;

    this.isCopy = false;

    this.rowSetNo = "";
    this.ccc = ""; // credit card company
    this.traderNo = "";
    this.resultText = "";
    this.accountsDate = ''; // date of last accounts
    this.accountsTime = ''; // time of last accounts
    this.sumSign = ''; // + or -
    this.sum = ''; // sum of last accounts
    this.barAmount = ''; // bargain amount of last accounts
    this.barCount = ''; // bargain transactions of last accounts
    this.cancelAmount = ''; // overall amount of cancelled transactions (last accounts)
    this.cancelCount = ''; // cancel transactions of last accounts
    this.adviceAmount = ''; // overall credit advice sum (last accounts)
    this.adviceCount = ''; // credit advice transactions of last accounts

    this.diff = ''; // difference since last accounts
}

CBalanceDataSet.prototype.print = function(printer,
    terminalId,
    bargainText,
    cancelText,
    adviceText) {
    printer.addLine("B", 1, false, 0);
    //printer.addElement(formatDateString(this.accountsDate, "dd.mm.20yy"),
    //printer.addElement(formatTimeString(this.accountsTime, "hh:MM"),
    printer.addLine("A", 1, false, 2);

    printer.addLine("A", 1, false, 0);
    printer.addElement(this.ccc, 0, 0, true, 0, 41);

    printer.addLine("A", 1, false, 0);
    printer.addElement(this.traderNo, 0, 0, false, 0, 17);
    //printer.addElement(terminalId, 18, 1, false, 18, 41);
    printer.addElement(this.accountsDate, 34, 1, true, 28, 34);
    printer.addElement(this.accountsTime, 41, 1, true, 35, 41);
    printer.addLine("A", 1, false, 2);

    printer.addLine("A", 1, false, 0);
    printer.addElement(this.resultText, 0, 0, false, 0, 41);
    printer.addLine("A", 1, false, 0);

    if (this.type & 8) {
        // Payed
        printer.addLine("A", 1, false, 0);
        printer.addElement(bargainText, 0, 0, false, 0, 41);
        printer.addLine("A", 1, false, 0);
        printer.addElement(this.barCount, 0, 0, false, 0, 5);
        printer.addElement(float2StringD2(this.barAmount) + " &euro;", 41, 1, true, 18, 41);
        // Cancelled
        printer.addLine("A", 1, false, 0);
        printer.addElement(cancelText, 0, 0, false, 0, 41);
        printer.addLine("A", 1, false, 0);
        printer.addElement(this.cancelCount, 0, 0, false, 0, 5);
        printer.addElement(float2StringD2(this.cancelAmount) + " &euro;", 41, 1, true, 18, 41);
        // Adviced
        printer.addLine("A", 1, false, 0);
        printer.addElement(adviceText, 0, 0, false, 0, 41);
        printer.addLine("A", 1, false, 0);
        printer.addElement(this.adviceCount, 0, 0, false, 0, 5);
        printer.addElement(float2StringD2(this.adviceAmount) + " &euro;", 41, 1, true, 18, 41);
    }
    if (this.type & 2 || this.sum != null) // sum
    {
        printer.addLine("A", 1, false, 0);
        printer.addDivisionLine();
        printer.addLine("A", 2, false, 2);
        printer.addElement(this.sumSign + " " + float2StringD2(this.sum) + " &euro;",
            41, 1, true, 18, 41);
    }
    if (this.type & 32) {
        printer.addLine("A", 1, false, 0);
        printer.addElement(this.resultText, 0, 0, false, 0, 41);
        printer.addLine("A", 2, false, 0);
        printer.addElement(this.diffSign + " " + float2StringD2(this.diff) + " &euro;",
            41, 1, true, 0, 41);
    }
    printer.addLine("A", 1, false, 2);
    printer.addDivisionLine();
}

CBalanceDataSet.prototype.toString = function() {
    return this.rowSetNo + this.ccc + this.traderNo + this.resultText +
        this.accountsDate + this.accountsTime + this.sumSign +
        this.sum + this.barAmount + this.barCount + this.cancelAmount +
        this.cancelCount + this.adviceAmount + this.adviceCount +
        this.diffSign + this.diff + "\n";
}

// ---------------------------------------------------------------------------
// object  CVoucher
// extends -
// ---------------------------------------------------------------------------
function CVoucher() {
    this.terminalId = "";
    this.resultText = "";
    this.amount = "";
}

CVoucher.prototype.print = function() {}

CVoucher.prototype.printBon = function(printer) {}

// ---------------------------------------------------------------------------
// object  CAccountsVoucher
// extends CVoucher
// ---------------------------------------------------------------------------
function CCreditBalanceVoucher() {
    this.czId = ""; // clearing centre id
    this.rowSetCount = ""; // row set count for administrative results
    this.bargainText = ""; // print text in administrative resultsets for case 'bargain'
    this.cancelText = ""; // print text in administrative resultsets for case 'cancel'
    this.adviceText = ""; // print text in administrative resultsets for case 'credit advice'

    this.dataSets = [];
}

CCreditBalanceVoucher.prototype = new CVoucher;

CCreditBalanceVoucher.prototype.print = function() {
    printer = new CPrinter();
    var me = this;
    var defret = jQuery.Deferred();
    $.when(printer.head()).done(function() {
        printer.addLine("A", 1, false, 0);
        text = currentDateString("dd.mm.yyyy");
        printer.addElement(text, 0, 0, false, 0, 41);

        printer.addDivisionLine();

        for (i = 0; i < me.dataSets.length; i++) {
            dataSet = me.dataSets[i];
            dataSet.print(printer, me.terminalId, me.bargainText,
                me.cancelText, me.adviceText);
        }

        printer.print();
        defret.resolve();
    });
    return defret.promise();
}

CCreditBalanceVoucher.prototype.complete = function() {
    var i = parseInt(this.rowSetCount);
    if (i == 'NaN')
        return false;

    return (i == this.dataSets.length);
}

CCreditBalanceVoucher.prototype.toString = function() {
    var ret = this.czId + this.rowSetCount + this.bargainText + this.cancelText +
        this.adviceText + "\n";

    for (i = 0; i < this.dataSets.length; i++) {
        ret += this.dataSets[i].toString();
    }

    return ret;
}

// ---------------------------------------------------------------------------
// object  CKreditCardVoucher
// extends CVoucher
// ---------------------------------------------------------------------------
function CCreditCardVoucher(isCopy) {
    this.DBId = "CCP";
    this.ccc = "";
    this.creditCardNo = "";
    this.source = "";
    this.expiration = "";
    this.traderNo = "";
    this.voucherNo = "";
    this.acceptanceNo = "";
    this.refAmount = "";
    this.refVoucher = "";
    this.isCopy = isCopy;
}

CCreditCardVoucher.prototype = new CVoucher;

CCreditCardVoucher.prototype.print = function() {
    printer = new CPrinter();
    var me = this;
    var defret = jQuery.Deferred();
    $.when(printer.head()).done(function() {
        printer.addLine("A", 1, false, 0);
        printer.addElement(me.ccc, 0, 0, true, 0, 41);
        printer.addLine("A", 1, false, 0);
        text = me.creditCardNo + " (" + me.source + ")";
        printer.addElement(text, 0, 0, false, 0, 25);
        text = me.expiration;
        printer.addElement(text, 41, 1, false, 27, 41);

        printer.addLine("A", 1, false, 3);

        printer.addLine("A", 1, false, 0);
        printer.addElement(me.traderNo, 0, 0, false, 0, 17);
        printer.addElement(me.terminalId, 41, 1, false, 20, 41);

        if (me.refAmount != "" && me.refAmount != "00000000") {
            printer.addLine("A", 1, false, 0);
            printer.addElement(me.refAmount, 0, 0, false, 0, 8);
            if (me.refVoucher)
                text = "Referenzbeleg Nr.:" + me.refVoucher;
            printer.addElement(text, 41, 1, false, 9, 41);
        }

        printer.addLine("A", 1, false, 0);
        text = "Genehmigungsnummer:" + me.acceptanceNo;
        printer.addElement(text, 41, 1, false, 0, 41);

        printer.addLine("A", 1, false, 0);
        text = "Belegnummer:" + me.voucherNo;
        printer.addElement(text, 41, 1, false, 0, 41);

        printer.addLine("A", 1, false, 3);

        if (me.isCopy) {
            printer.addLine("A", 1, false, 0);
            printer.addElement("DUPLIKAT", 0, 0, false, 0, 21);
        }

        printer.addLine("A", 1, false, 3);

        printer.addLine("A", 1, false, 0);
        printer.addElement(me.resultText, 0, 0, false, 0, 21);
        text = "  EUR" + float2StringD2(me.amount);
        printer.addElement(text, 41, 1, false, 22, 41);

        printer.addLine("A", 1, false, 3);

        printer.addLine("A", 1, false, 0);
        text = currentDateString("dd.mm.yyyy") + " " + currentTimeString("hh:MM");
        printer.addElement(text, 0, 0, false, 0, 41);

        printer.addLine("A", 1, false, 3);

        printer.addLine("A", 1, false, 0);
        printer.addElement("Unterschrift:", 0, 0, false, 0, 41);

        printer.addLine("A", 1, false, 3);
        printer.addLine("A", 1, false, 3);
        printer.addLine("A", 1, false, 3);
        printer.addLine("A", 1, false, 3);

        printer.print();
        defret.resolve();
    });
    return defret.promise();
}

CCreditCardVoucher.prototype.printBon = function(printer) {
    //var defret = $.Deferred()
    printer.addLine("B", 1, false, 0);
    printer.addElement(this.resultText, 0, 0, false, 0, 20);
    printer.addElement(this.terminalId, 55, 1, false, 36, 55);
    printer.addLine("B", 1, false, 0);
    printer.addElement(this.ccc, 0, 0, false, 0, 20);
    printer.addElement(this.acceptanceNo, 55, 1, false, 36, 55);
    printer.addLine("B", 1, false, 0);
    var text = this.creditCardNo + " (" + this.source + ")";
    printer.addElement(text, 0, 0, false, 0, 26);
    printer.addElement(this.expiration, 55, 1, false, 42, 55);
    printer.addLine("B", 1, false, 0);
    printer.addElement(this.traderNo, 0, 0, false, 0, 22);
    text = "Belegnummer:" + this.voucherNo;
    printer.addElement(text, 55, 1, false, 36, 55);
    return 0;
    //return defret.promise();
}

// ---------------------------------------------------------------------------
// object  CDebitBalanceVoucher
// extends CVoucher
// ---------------------------------------------------------------------------
function CDebitBalanceVoucher() {
    this.result = "";
    this.sum = "";
    this.voucherRows = new Array();
}

CDebitBalanceVoucher.prototype = new CVoucher;

CDebitBalanceVoucher.prototype.print = function(isShiftSum) {
    printer = new CPrinter();
    var defret = jQuery.Deferred();
    var me = this;
    $.when(printer.head()).done(function() {
        printer.addLine("A", 1, false, 0);
        if (typeof isShiftSum == undefined || isShiftSum == false)
            text = POS.lang.getText("LABELS", "DEBITCARD_BALANCE");
        else
            text = POS.lang.getText("LABELS", "DEBITCARD_SHIFTSUM");
        printer.addElement(text, 20, 2, true, 0, 41);

        printer.addDivisionLine();

        printer.addLine("A", 1, false, 0);
        printer.addElement(me.resultText, 0, 0, false, 0, 41);
        printer.addLine("A", 1, false, 0);
        printer.addElement(me.result, 0, 0, false, 0, 41);
        for (var i = 0; i < me.voucherRows.length; i++) {
            printer.addLine("A", 1, false, 0);
            var row = me.voucherRows[i];
            printer.addElement(row, 0, 0, false, 0, 41);
        }
        printer.addLine("A", 1, false, 5);

        printer.print();
        defret.resolve();
    });
    return defret.promise();
}

// ---------------------------------------------------------------------------
// object  CDebitVoucher
// extends CVoucher
// ---------------------------------------------------------------------------
function CDebitVoucher() {
    this.DBId = "DCP";
    this.result = "";
    this.subscriptionField = false;
    this.voucherRows = new Array();
}

CDebitVoucher.prototype = new CVoucher;

CDebitVoucher.prototype.printBon = function(printer) {
    //var defret = $.Deferred();
    printer.addLine("B", 1, false, 0);
    printer.addElement(this.resultText, 0, 0, false, 0, 55);
    printer.addLine("B", 1, false, 0);
    printer.addElement(this.result, 0, 0, false, 0, 55);
    for (var i = 0; i < this.voucherRows.length; i++) {
        printer.addLine("B", 1, false, 0);
        var row = this.voucherRows[i];
        printer.addElement(row, 0, 0, false, 0, 55);
    }
    if (this.subscriptionField == true) {
        printer.addLine("B", 1, false, 0);
        printer.addElement("Unterschrift:", 0, 0, false, 0, 55);
        printer.addLine("B", 1, false, 5);
    }
    printer.addLine("B", 1, false, 5);
    //return defret.promise();
    return 0;
}

CDebitVoucher.prototype.toString = function() {
    return "tid=" + this.transId + " termid=" + this.terminalId + " amount=" + this.amount +
        " mac=" + this.mac + " date=" + this.date + "\n";
}

export { CVoucher, CBalanceDataSet, CCreditBalanceVoucher, CCreditCardVoucher, CDebitBalanceVoucher, CDebitVoucher };
